import * as Ids from '@utils/ids';
import { getCookie } from '@utiljs/cookie';
import { stringify } from '@utiljs/param';
import { getBusinessLineByUrl } from '@utils/getEnv';
import { reportCustomMetrics, CUSTOM_METRICS } from '@utils/owlReporter';
import Horn from '@utils/horn';
import * as API from '../api';
import doLogout from '../utils/doLogout';

const checkJumpToSC = (token: string): Promise<void> => {
    return new Promise(resolve => {
        API.checkSCIndex().then(
            res => {
                if (res.code === 0) {
                    const data = res.data;
                    const scIndex = data.scIndex;
                    const scIndexUrl = data.scIndexUrl;

                    if (scIndex && scIndexUrl) {
                        if (window.wmSystemApi && window.wmSystemApi.setBusinessLine) {
                            window.wmSystemApi.setBusinessLine(getBusinessLineByUrl(scIndexUrl), {
                                acctId: Ids.getAcctId(),
                            });
                        }

                        const params = {
                            token: token || Ids.getToken(),
                            acctId: Ids.getAcctId(),
                            region_id: getCookie('region_id'),
                            region_version: getCookie('region_version'),
                            wmPoiId: Ids.getWmPoiId(),
                            // eslint-disable-next-line @typescript-eslint/camelcase
                            device_uuid: getCookie('device_uuid'),
                            bsid: getCookie('bsid'),
                            hash: window.location.hash,
                        };
                        // Farewell
                        // @ts-ignore
                        window.goingToSC = true;
                        window.location.href = `${scIndexUrl}?${stringify(params)}`;
                    } else {
                        if (window.wmSystemApi && window.wmSystemApi.setBusinessLine) {
                            window.wmSystemApi.setBusinessLine('waimai', {
                                acctId: Ids.getAcctId(),
                            });
                        }
                        resolve();
                    }
                } else {
                    reportCustomMetrics(CUSTOM_METRICS.ACCOUNT_JUMP_FAIL.KEY, 1, {
                        [CUSTOM_METRICS.ACCOUNT_JUMP_FAIL.TAGS.REASON]: `Code:${res.code}`,
                        [CUSTOM_METRICS.ACCOUNT_JUMP_FAIL.TAGS.ACCTID]: Ids.getAcctId(),
                        [CUSTOM_METRICS.ACCOUNT_JUMP_FAIL.TAGS.SCINDEX]: window.scIndex,
                    });
                    // 闪购(scIndex === 1)，医药scIndex === 2商家失败后踢蹬
                    if (window.scIndex !== 0 && res.code === 1001) {
                        const shouldLogout = Horn.getConfigByFieldName<{
                            scIndexLogout?: boolean;
                        }>(Horn.CONFIG_FIELD.SC_INDEX_CONFIG);
                        if (shouldLogout) {
                            doLogout();
                            reportCustomMetrics(CUSTOM_METRICS.ACCOUNT_JUMP_FAIL_LOGOUT.KEY, 1, {
                                [CUSTOM_METRICS.ACCOUNT_JUMP_FAIL_LOGOUT.TAGS
                                    .ACCTID]: Ids.getAcctId(),
                                [CUSTOM_METRICS.ACCOUNT_JUMP_FAIL_LOGOUT.TAGS.SCINDEX]:
                                    window.scIndex,
                            });
                        }
                    } else {
                        resolve();
                    }
                }
            },
            () => {
                reportCustomMetrics(CUSTOM_METRICS.ACCOUNT_JUMP_FAIL.KEY, 1, {
                    [CUSTOM_METRICS.ACCOUNT_JUMP_FAIL.TAGS.REASON]: `NetworkError`,
                    [CUSTOM_METRICS.ACCOUNT_JUMP_FAIL.TAGS.ACCTID]: Ids.getAcctId(),
                    [CUSTOM_METRICS.ACCOUNT_JUMP_FAIL.TAGS.SCINDEX]: window.scIndex,
                });
                resolve();
            },
        );
    });
};

export default checkJumpToSC;
